import { Button, VbzInputText } from '@smiles/voebiz-ui-kit';
import { FilterIcon, IncludeTeamIcon, MoreActionsIcon, SearchIcon, DeactivateTeamIcon } from 'components';
import { Dropdown, DropdownOptions } from 'components/Dropdown';
import IncludeManyPeople from 'components/Icons/IncludeManyPeople';
import IncludeOnePerson from 'components/Icons/IncludeOnePerson';
import ListIcon from 'components/Icons/ListIcon';
import ShareIcon from 'components/Icons/ShareIcon';
import ModalBeneficiariesDeactivation from 'components/ModalDeactive';
import ModalFilter from 'components/ModalFilter';
import ModalInclude from 'components/ModalInclude';
import { useBeneficiaries } from 'contexts/Beneficiaries';
import { useExportCsv } from 'contexts/ExportCsv';
import debounce from 'lodash/debounce';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { stringSearch } from 'utils/stringSearch';

const TableSearch = () => {
  const { exportCsv } = useExportCsv();

  const [searchParams, setParams] = useSearchParams();

  const paramsModal = searchParams.get('m');

  const { isEmpty, setFilter, filter, isEmptyFilter, getListBeneficiaries } = useBeneficiaries();

  const navigate = useNavigate();

  const { t } = useTranslation('beneficiaries');

  const [openFilterModal, setOpenFilterModal] = useState(false);

  const [typeInclude, setTypeInclude] = useState('one');

  const [openDropdownInclude, setOpenDropdownInclude] = useState(false);

  const [openDropdownMoreActions, setOpenDropdownMoreActions] = useState(false);

  const [openModalInclude, setOpenModalInclude] = useState(false);
  const [openDeactivation, setOpenDeactivation] = useState(false);
  const handleCloseModal = () => {
    setOpenFilterModal(false);
  };

  const handleCloseDeactiationModal = () => {
    setOpenDeactivation(false);
  };

  const handleOpenModal = () => {
    setOpenFilterModal(true);
  };

  const isFilterModalClosed = !openFilterModal;

  const handleFilterChange = debounce((key?: string) => {
    const search = stringSearch(key);

    setFilter({ search });
  }, 400);

  const handleCleanFilter = () => {
    setFilter({ search: undefined });
  };

  const handleOpenDropdownInclude = () => {
    setOpenDropdownInclude(true);
  };

  const handleOpenDeativeModal = () => {
    setOpenDeactivation(true);
  };

  const handleOpenDropdownMoreActions = () => {
    setOpenDropdownMoreActions(true);
  };

  const handleOpenModalInclude = (type: string) => {
    setOpenDropdownInclude(false);
    setOpenModalInclude(true);
    setTypeInclude(type);
  };

  const handleCloseModalInclude = () => {
    setOpenModalInclude(false);
    getListBeneficiaries();
  };

  useEffect(() => {
    document.body.classList.remove('unscrollable');
  }, [isFilterModalClosed]);

  const optionsInclude = useMemo<DropdownOptions[]>(
    () => [
      {
        onClick: () => handleOpenModalInclude('one'),
        label: t('include_one'),
        icon: <IncludeOnePerson />,
      },
      {
        onClick: () => handleOpenModalInclude('many'),
        label: t('include_many'),
        icon: <IncludeManyPeople />,
      },
    ],
    [t],
  );

  const optionsMoreOptions = useMemo<DropdownOptions[]>(
    () => [
      {
        onClick: () => navigate('?p=historico-importacoes'),
        label: t('historic'),
        icon: <ListIcon />,
      },
      {
        onClick: () => exportCsv(),
        label: t('export_list'),
        icon: <ShareIcon />,
      },
    ],
    [t, navigate, exportCsv],
  );

  useEffect(() => {
    if (paramsModal === 'dropdown-modal-include') {
      setOpenModalInclude(true);
      setTypeInclude('many');
      setParams('');
    }

    if (paramsModal === 'dropdown-modal-deactivate') {
      handleOpenDeativeModal();
      setParams('');
    }
  }, [paramsModal, setParams]);

  const classButtonMoreOptions = isEmpty
    ? 'button-more-actions btn-common-actions border-disabled'
    : 'button-more-actions btn-common-actions';

  return (
    <div className="w-100 container-table-header">
      <div className="w-100 search-input-container">
        <VbzInputText
          className="input-search"
          value={filter?.search}
          onChange={({ target }) => handleFilterChange(target.value)}
          placeholder={t('search')}
          icon={
            <>
              {filter?.search && (
                <button
                  type="button"
                  className="icon-clear"
                  data-testid="button-clear-search"
                  onClick={() => handleCleanFilter()}
                >
                  <i className="material-icons">close</i>
                </button>
              )}
              <SearchIcon />
            </>
          }
        />
      </div>
      <div className="action-groups-container">
        <div className="w-100 button-filter-container container-btn-common">
          <Button
            className={`button-filter btn-common-actions ${!isEmptyFilter && 'filter-active'} ${
              isEmpty && 'border-disabled'
            }`}
            icon={isEmptyFilter ? <FilterIcon disabled={isEmpty} /> : null}
            disabled={isEmpty}
            onClick={() => handleOpenModal()}
          >
            {t('filter_text')}

            {!isEmptyFilter && <i className="material-icons">close</i>}
          </Button>
        </div>
        <div className="w-100 button-include-team-container container-btn-common beneficiaries-dropdown">
          <Button
            className="button-include-team btn-common-actions"
            icon={<DeactivateTeamIcon />}
            onClick={handleOpenDeativeModal}
          >
            {t('deactivate_team_text')}
          </Button>
        </div>
        <div className="w-100 button-include-team-container container-btn-common beneficiaries-dropdown">
          <Button
            className="button-include-team btn-common-actions"
            icon={<IncludeTeamIcon />}
            onClick={handleOpenDropdownInclude}
          >
            {t('include_team_text')}
          </Button>
          <Dropdown
            close={() => setOpenDropdownInclude(false)}
            open={openDropdownInclude}
            options={optionsInclude}
            id="dropdown-modal-include"
          />
        </div>
        <div className="w-100 button-more-actions-container container-btn-common beneficiaries-dropdown">
          <Button
            className={classButtonMoreOptions}
            icon={<MoreActionsIcon disabled={isEmpty} />}
            disabled={isEmpty}
            onClick={() => handleOpenDropdownMoreActions()}
          >
            {t('more_actions_text')}
          </Button>
          <Dropdown
            close={() => setOpenDropdownMoreActions(false)}
            open={openDropdownMoreActions}
            options={optionsMoreOptions}
            id="dropdown-more-options"
          />
        </div>
      </div>
      <ModalFilter isOpen={openFilterModal} closeModal={handleCloseModal} />

      <ModalInclude
        isOpen={openModalInclude}
        closeModal={handleCloseModalInclude}
        setTab={setTypeInclude}
        type={typeInclude}
      />

      <ModalBeneficiariesDeactivation isOpen={openDeactivation} closeModal={handleCloseDeactiationModal} />
    </div>
  );
};

export default TableSearch;
